import React from 'react';

const LogoImage = ({ className, title = 'Reserberry', preferBrand = false }) => {
  // Opcionales de marca (solo si preferBrand=true)
  const brandCandidates = [
    process.env.PUBLIC_URL + '/brand/feature_graphic_1024x500.png',
    process.env.PUBLIC_URL + '/brand/feature_graphic_1024x500.jpg',
    process.env.PUBLIC_URL + '/brand/feature_graphic_1024x500.webp',
    process.env.PUBLIC_URL + '/brand/feature_graphic.png',
    process.env.PUBLIC_URL + '/brand/feature_graphic.jpg',
    process.env.PUBLIC_URL + '/brand/feature_graphic.webp',
    process.env.PUBLIC_URL + '/brand/nav-logo.png',
    process.env.PUBLIC_URL + '/brand/reserberry-hero.png',
    process.env.PUBLIC_URL + '/brand/logo.png'
  ];
  // Iconos por defecto (app)
  const iconCandidates = [
    process.env.PUBLIC_URL + '/icons/icon-512.png?v=5',
    process.env.PUBLIC_URL + '/icons/icon-192.png?v=5'
  ];
  const candidates = preferBrand ? [...brandCandidates, ...iconCandidates] : iconCandidates;
  const [index, setIndex] = React.useState(0);
  const [useSvg, setUseSvg] = React.useState(false);

  const handleError = () => {
    if (index < candidates.length - 1) {
      setIndex((i) => i + 1);
    } else {
      setUseSvg(true);
    }
  };

  if (useSvg) {
    return (
      <svg
        viewBox="0 0 48 48"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-label="logo"
        role="img"
        title={title}
      >
        <defs>
          <linearGradient id="g" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#ec4899" />
            <stop offset="100%" stopColor="#be185d" />
          </linearGradient>
        </defs>
        <rect x="0" y="0" width="48" height="48" rx="10" fill="url(#g)" />
        <rect x="10" y="12" width="28" height="24" rx="4" fill="#ffffff" />
        <rect x="10" y="12" width="28" height="6" rx="4" fill="#f472b6" />
        <circle cx="16" cy="15" r="1.8" fill="#ffffff" />
        <circle cx="32" cy="15" r="1.8" fill="#ffffff" />
        <path d="M14 22h20M14 28h20M14 34h12" stroke="#374151" strokeWidth="2" strokeLinecap="round" />
      </svg>
    );
  }

  return (
    <img
      src={candidates[index]}
      alt="Logo"
      className={className}
      onError={handleError}
      title={title}
    />
  );
};

export default LogoImage;


